module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.24dd8f42.woff";